import { h, render } from 'preact';

import { preactWidget } from '../../utils';
import widgetPushNotifications from '../auto-push-notifications/widget';

import widget from './widget-config';
import { SlimBannerComponent } from './component';

export const hydrate = () => {
  const { $root, props } = preactWidget(widget);
  const { props: pushNotificationsProps } = preactWidget(widgetPushNotifications);
  render(
    <SlimBannerComponent
      htmlProps={props.htmlProps}
      htmlPushNotificationsProps={pushNotificationsProps?.htmlProps}
      widget={widget}
      $root={$root}
    />,
    $root
  );
};
